module.exports = __webpack_public_path__ + "static/img/yeswecan0006.7d3455b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0006.png
// module id = 581
// module chunks = 1